export default __webpack_public_path__ + "static/media/growingWallMobile.2a1a86ed.svg";